import { render, staticRenderFns } from "./ConfirmPhoneArea.vue?vue&type=template&id=936c8208&"
import script from "./ConfirmPhoneArea.vue?vue&type=script&lang=ts&"
export * from "./ConfirmPhoneArea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports